import React from 'react';
import styled from 'styled-components';
import { ValidatorComponent } from 'react-form-validator-core';

import { InputErrorMessage } from './InputMessage';
import Textarea from './Textarea';

class ValidatedTextarea extends ValidatorComponent {
  render() {
    const { errorMessages, validators, requiredError, validatorListener, ...rest } = this.props;
    const invalid = !this.isValid();

    return (
      <InputCont>
        <Textarea error={invalid} {...rest} />
        {invalid && <TextareaErrorMessage data-test-error={rest.name}>{this.getErrorMessage()}</TextareaErrorMessage>}
      </InputCont>
    );
  }
}

const InputCont = styled.div`
  position: relative;
`;

const TextareaErrorMessage = styled(InputErrorMessage)`
  position: relative;
  top: 0;
  &:before {
    height: 96px;
    top: -109px;
  }
`;

export default ValidatedTextarea;
